var collapsible_list_pair_rtlignore_default = {
  "container": "UfDyV",
  "title": "FPyDH",
  "viewerContainer": "_1n3i3",
  "titleContainer": "FMcOw",
  "expandIcon": "_0--Hh",
  "dndIcon": "_7c4OT",
  "RTL": "_-4BWx",
  "LTR": "mv6Da",
  "itemContainer": "V7Yu5",
  "itemContainerViewer": "tJLLb",
  "mouseDown": "y8LbA",
  "innerEditor": "FXHR4",
  "item": "Qd-Py",
  "floatingAddPluginMenuWrapper": "v7y3l",
  "childrenHidden": "ASr2H"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
